import axios from "axios";
import {isTokenExpired} from "./tokenUtils";
import {sweetAlerts} from "./sweet-alerts";

// Create axios instance
const api = axios.create();

// Request interceptor to add token
api.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem("auth_token");
		if (token && !isTokenExpired(token)) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// Response interceptor to handle token expiration
api.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		// Check if the error is due to token expiration
		if (error.response?.status === 401 || error.response?.status === 403) {
			// Show logout message
			sweetAlerts("error", "Your login has been completed by the team, log in again");

			// Clear localStorage
			localStorage.removeItem("auth_token");
			localStorage.removeItem("role");
			localStorage.removeItem("userDetails");

			// Dispatch logout action if store is available
			if (window.store) {
				window.store.dispatch({type: "USER_REMOVE"});
			}

			// Redirect to login page after a short delay to show the message
			setTimeout(() => {
				// window.location.href = HOME_URL + "/login";
				window.location.href = "/login";
			}, 2000);
		}

		return Promise.reject(error);
	}
);

export default api;
